var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.current_match && Object.keys(_vm.current_match).length
    ? _c("ul", { staticClass: "match-tabs-wrap" }, [
        _c(
          "li",
          {
            class: [
              "no-select",
              { active: _vm.parentRoute === _vm.CFG_MODULES.GAME_PLAN.route },
            ],
          },
          [
            _c(
              "a",
              {
                attrs: {
                  href: _vm.getHrefFor(_vm.CFG_MODULES.GAME_PLAN.route),
                },
              },
              [_vm._v(_vm._s(_vm.translations.game_plan_label))]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            ref: "lineup-builder",
            class: [
              "no-select",
              { active: _vm.parentRoute === _vm.CFG_MODULES.LINEUP.route },
              {
                "btn-disabled":
                  _vm.parentRoute !== _vm.CFG_MODULES.LINEUP.route &&
                  !_vm.current_match.show_lineup,
              },
            ],
          },
          [
            _c(
              "a",
              { attrs: { href: _vm.getHrefFor(_vm.CFG_MODULES.LINEUP.route) } },
              [_vm._v(_vm._s(_vm.translations.lineup_label) + "\n    ")]
            ),
          ]
        ),
        _vm._v(" "),
        _vm.current_match && _vm.current_match.sport_id == 1
          ? _c(
              "li",
              {
                class: [
                  "no-select",
                  {
                    active:
                      _vm.parentRoute === _vm.CFG_MODULES.MATCH_INFO.route,
                  },
                ],
              },
              [
                !_vm.is_custom_client.status
                  ? _c(
                      "a",
                      {
                        attrs: {
                          href: _vm.getHrefFor(
                            _vm.CFG_MODULES.MATCH_INFO.route
                          ),
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.translations.match_info_label) + "\n    "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            )
          : _c("li", { staticClass: "no-select btn-disabled" }, [
              _c("a", [_vm._v(_vm._s(_vm.translations.match_info_label))]),
            ]),
        _vm._v(" "),
        _vm.current_match
          ? _c(
              "li",
              {
                class: [
                  "no-select",
                  {
                    active: _vm.parentRoute === _vm.CFG_MODULES.SCORECARD.route,
                  },
                ],
              },
              [
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.getHrefFor(_vm.CFG_MODULES.SCORECARD.route),
                    },
                  },
                  [_vm._v(_vm._s(_vm.translations.scorecard_label))]
                ),
              ]
            )
          : _c("li", { staticClass: "no-select btn-disabled" }, [
              _c("a", [_vm._v(_vm._s(_vm.translations.scorecard_label))]),
            ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }